import { render, staticRenderFns } from "./PaymentMethodLabel.vue?vue&type=template&id=440be6cc"
import script from "./PaymentMethodLabel.vue?vue&type=script&lang=js"
export * from "./PaymentMethodLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports